export enum SkillTypes {
  Speak = 'speak',
  Listen = 'listen',
  Read = 'read',
  Grammar = 'grammar',
  Spelling = 'spelling',
  Vocabulary = 'vocabulary',
}

export enum ActivityTypes {
  OpenWriting = 'openWriting',
  NaturalConversation = 'naturalConversation',
  Memory = 'memory',
  Read = 'read',
  Vocabulary = 'vocabulary',
  Spelling = 'spelling',
  Listen = 'listen',
  Speak = 'speak',
  ImageToText = 'imageToText',
  TextToImage = 'textToImage',
  TextToText = 'textToText',
  Grammar = 'grammar',
}
